import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=31b1c5c2&"
import script from "./ViewDetail.vue?vue&type=script&lang=ts&"
export * from "./ViewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ViewDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports